<template>
  <div class="text-center">
    <v-avatar size="100" color="success">
      <v-icon class="ml-2" size="60">mdi-send</v-icon>
    </v-avatar>
    <div class="mt-5">{{ message }}</div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  message: string;
}>();
</script>
